const config = {
  default: {
    name: "Trackmydoc",
    domainName: "trackmydoc.com",
    intractName: "Trackmydoc",
    intractEmail: "trackmydoc@gmail.com",
    firmType: "cpa",
  },
  "law-client.trackmydoc.com": {
    name: "Lawyer",
    domainName: "lawyer.com",
    logo: "/assets/logo/logo.png",
    favicon: "/assets/logo/favicon.ico",
    intractName: "Trackmydoc",
    intractEmail: "trackmydoc@gmail.com",
    firmType: "lawyer",
  }
};

const getSiteConfig = () => {
  const hostname = window.location.hostname;
  const matchedKey = Object.keys(config).find((key) => hostname.includes(key));
  return config[matchedKey] || config["default"];
};

const siteConfig = getSiteConfig();

export default siteConfig;
